import { AnimationCreateOptions, AnimationView } from "./AnimationView";

export class AnimationTemplates {
    private static fromTo(
        { targets, timeline, itemOptions }: AnimationCreateOptions,
        from: any,
        to: any,
    ): void {
        timeline.fromTo(targets, from, {
            ...to,
            stagger: itemOptions.stagging,
            duration: itemOptions.duration,
        });
        // targets.forEach((item, index) => {
        //     console.log("DELAY", index * (itemOptions.stagging || 0));
        //     timeline.fromTo(
        //         item,
        //         from,
        //         {
        //             ...to,
        //             // stagger: itemOptions.stagging,
        //             duration: itemOptions.duration,
        //             // delay: index * (itemOptions.stagging || 0),
        //         },
        //         index * (itemOptions.stagging || 0),
        //     );
        // });
    }

    public static register(view: AnimationView): void {
        view.register({
            key: "fade-in",
            title: "Fade In",
            create: (options) => {
                AnimationTemplates.fromTo(
                    options,
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                        clearProps: "opacity",
                    },
                );
            },
        });

        view.register({
            key: "fade-out",
            title: "Fade Out",
            create: (options) => {
                AnimationTemplates.fromTo(
                    options,
                    {
                        opacity: 1,
                    },
                    {
                        opacity: 0,
                        // clearProps: "opacity",
                    },
                );
            },
        });

        view.register({
            key: "fade-up",
            title: "Fade Up",
            create: (options) => {
                AnimationTemplates.fromTo(
                    options,
                    {
                        opacity: 0.15,
                        transform: "none",
                    },
                    {
                        opacity: 1,
                        transform: "translate3d(0, 32px, 0)",
                        clearProps: "opacity,transform",
                    },
                );
            },
        });

        view.register({
            key: "slide-up",
            title: "Slide Up",
            create: (options) => {
                AnimationTemplates.fromTo(
                    options,
                    {
                        transform: "translate3d(0, 64px, 0)",
                        opacity: 0,
                    },
                    {
                        transform: "none",
                        opacity: 1,
                        clearProps: "transform,opacity",
                    },
                );
            },
        });

        view.register({
            key: "scale-up",
            title: "Scale Up",
            create: (options) => {
                AnimationTemplates.fromTo(
                    options,
                    { transform: "scale(0.9)", opacity: 0 },
                    {
                        transform: "none",
                        opacity: 1,
                        clearProps: "transform, opacity",
                    },
                );
            },
        });

        view.register({
            key: "clip-path-inset",
            title: "Clip Path Inset",
            create: (options) => {
                AnimationTemplates.fromTo(
                    options,
                    { transform: "scale(0.8)", opacity: 0.3 },
                    {
                        transform: "none",
                        opacity: 1,
                        clearProps: "transform, opacity",
                    },
                );
            },
        });

        view.register({
            key: "text-lines",
            title: "Text Lines (Experimental)",
            filter: ({ props }) => {
                return props.name === "jsidea/text-box";
            },
            create: ({ targets, timeline, itemOptions }) => {
                SplitText.create(targets[0], {
                    type: "chars, words",
                    reduceWhiteSpace: false,
                    autoSplit: true,
                    onSplit: (self) => {
                        return timeline.from(self.chars, {
                            duration: itemOptions.duration,
                            stagger: itemOptions.stagging || 0.2,
                            opacity: 0.25,
                            clearProps: "opacity",
                        });
                    },
                });
            },
        });

        view.register({
            key: "line-stagging",
            title: "Line Stagging (Experimental)",
            filter: ({ props }) => {
                return props.name === "jsidea/text-box";
            },
            create: ({ targets, timeline, itemOptions }) => {
                var progress = 0;

                SplitText.create(targets[0], {
                    type: "lines",
                    reduceWhiteSpace: false,
                    autoSplit: true,
                    onSplit: (split) => {
                        const t = timeline.getById("p-");
                        if (t) {
                            timeline.remove(t);
                        }

                        var tl = timeline.fromTo(
                            split.lines,
                            {
                                id: "p-",
                                rotationX: -100,
                                transformOrigin: "50% 50% -30px",
                                opacity: 0,
                            },
                            {
                                duration: itemOptions.duration,
                                stagger: itemOptions.stagging || 0.2,
                                rotationX: 0,
                                transformOrigin: "50% 50% 0px",
                                opacity: 1,
                                ease: "power2.inOut",
                                onUpdate: () => {
                                    if (tl) {
                                        progress = tl.progress();
                                    }
                                },
                                onComplete: () => {
                                    if (itemOptions.once) {
                                        split.revert();
                                    }
                                },
                            },
                            0,
                        );

                        let m = progress;
                        tl.progress(0);
                        tl.progress(m);
                    },
                });
            },
        });
    }
}
